import React, { useEffect, useState } from 'react'
import { IoCloseCircleOutline } from "react-icons/io5";
import { FaTrash, FaArrowRight, FaThList } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { getGroupsOptionCompleteList, saveGroupOption, updateGroupOption } from 'actions/Catalogs';
import { setGroupOptionById } from 'redux/catalog.slice';
import { notify } from 'utils';
import Loader from 'components/UI/Loader';

const ModalHeader = ({ title, onClose }) => (
  <div className='h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg'>
    <span className="text-white font-[Gravity] text-2xl font-bold">
      {title}
    </span>
    <IoCloseCircleOutline onClick={onClose} className='text-white text-4xl cursor-pointer' />
  </div>
)

const ModalCreateGroups = ({ isOpen, onClose }) => {
  const [showModal, setShowModal] = useState(false);
  const [nombreGrupo, setNombreGrupo] = useState('');
  const [estatus, setEstatus] = useState('Activo');
  const [nuevaRespuesta, setNuevaRespuesta] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [respuestas, setRespuestas] = useState(['Orgánicos', 'Inorgánicos', 'Líquidos']);

  const { groupOptionByIdList } = useSelector((state) => state.catalog);
  const dispatch = useDispatch();

  const agregarRespuesta = () => {
    if (nuevaRespuesta.trim() !== '') {
      setRespuestas([...respuestas, { description: nuevaRespuesta }]);
      setNuevaRespuesta('');
    }
  };

  const eliminarRespuesta = (index) => {
    const nuevas = [...respuestas];
    nuevas.splice(index, 1);
    setRespuestas(nuevas);
  };

  const handleClose = () => {
    onClose();
  };

  const validations = () => {
    if (nombreGrupo.trim() === '') {
      notify("error", "Por favor, ingrese la descripción del grupo.", 1200);
      return false;
    }

    if (!respuestas.length) {
      notify("error", "Debe registrar al menos una respuesta válida.", 1200);
      return false;
    }

    return true;
  }


  const saveResponse = async () => {
    const { id = 0, options = [] } = groupOptionByIdList || {};

    if (!validations()) return;

    setIsLoading(true); // 👉 Inicia loader

    try {
      const answers = respuestas
        .filter(option => {
          if (id > 0) {
            return !options.some(r => r.description === option.description);
          }
          return option?.description;
        })
        .map(option => option.description);

      const deleteAnswers = options
        .filter(option => !respuestas.some(r => r.id === option.id))
        .map(option => option.id);

      const payload = {
        "Description": nombreGrupo,
        "Answers": answers,
      };

      if (id > 0) {
        await dispatch(updateGroupOption({ ...payload, "DeleteAnswers": deleteAnswers, id, "Active": estatus === "Activo" }));
      } else {
        await dispatch(saveGroupOption(payload));
      }

      await dispatch(getGroupsOptionCompleteList());
      handleClose();
    } catch (error) {
      console.error("Error al guardar la pregunta:", error);
      notify("error", "Hubo un problema al guardar", 2000);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && groupOptionByIdList && Object.keys(groupOptionByIdList).length > 0) {
      const { description = '', active, options = [] } = groupOptionByIdList;
      setNombreGrupo(description);
      setEstatus(active ? 'Activo' : 'Inactivo');
      setRespuestas(options);
    }
  }, [isOpen, groupOptionByIdList]);

  useEffect(() => {
    if (!isOpen) {
      setNombreGrupo('');
      setEstatus('Activo');
      setRespuestas([]);
      setNuevaRespuesta('');
      if (groupOptionByIdList && Object.keys(groupOptionByIdList).length > 0) {
        dispatch(setGroupOptionById({}));
      }
    }
  }, [isOpen, dispatch, groupOptionByIdList]);


  if (!isOpen) return null;


  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <Loader /> {/* Tu componente loader */}
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`bg-white max-h-[90vh] overflow-y-auto rounded-xl shadow-lg w-[90vw] max-w-3xl relative transition-all duration-300 transform ${showModal ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <ModalHeader title={'Grupo de Respuestas'} onClose={onClose} />
        <div className='w-full h-[85%] p-5 flex flex-col'>
          <div className="flex justify-between items-center gap-2">
            <div className="flex flex-col w-1/2">
              <label>Nombre del Grupo:</label>
              <input
                className="bg-gray-200 rounded px-2 py-1"
                value={nombreGrupo}
                onChange={(e) => setNombreGrupo(e.target.value)}
                placeholder="Tipo de producto"
              />
            </div>

            <div className="flex flex-col w-1/2">
              <label>Estatus</label>
              <select
                className="bg-gray-200 rounded px-2 py-1"
                value={estatus}
                disabled={!groupOptionByIdList.id > 0}
                onChange={(e) => setEstatus(e.target.value)}
              >
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
            </div>
          </div>

          <div className='mt-4'>
            <div className="flex items-center gap-2 text-black font-semibold mb-2 border-b pb-1">
              <FaThList />
              <span>Respuestas posibles</span>
            </div>

            <div className="grid grid-cols-2 pt-2">
              <div className="flex flex-col gap-2">
                <label className='border-gray-400 border-b-2'>Nueva Respuesta</label>
                <input
                  className="w-[95%] bg-gray-200 rounded px-2 py-1"
                  value={nuevaRespuesta}
                  onChange={(e) => setNuevaRespuesta(e.target.value)}
                  placeholder="Tipo de producto"
                />
                <button
                  onClick={agregarRespuesta}
                  className="w-[95%] bg-black text-white py-1 rounded flex items-center justify-center gap-2 hover:bg-gray-800"
                >
                  Agregar <FaArrowRight />
                </button>
              </div>

              <div className='w-full border-gray-400 border-l-2 pl-4'>
                <div className='border-gray-400 border-b-2 w-full pl-3 font-semibold'>Respuestas</div>
                <ul className="mt-2 space-y-2 max-h-40 overflow-y-auto pr-2">
                  {respuestas.map(({ description }, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center border-gray-400 border-b-[1px] pl-7 py-1"
                    >
                      <span>{description}</span>
                      <button onClick={() => eliminarRespuesta(index)} className="text-black hover:text-red-500">
                        <FaTrash />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className='w-full flex justify-end gap-2 mt-auto pt-2'>
            <div className='h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]' onClick={handleClose}>Cancelar</div>
            <div className='h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]' onClick={saveResponse}>Guardar</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCreateGroups